/* @flow */

import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from '../../../link';
import {TwoLine} from '../../../two-line';
import {LeadAvatar} from '../../../lead/lead-avatar';

import './company-lead.css';

export type Lead = {|
    leadName: string,
    primaryContactName: string,
    htmlUrlPath: string,
    avatarUrl: string,
    formattedValue: string,
|};

type Props = {|
    ...Lead,
    onClose: () => void,
|};

export function CompanyLead(props: Props) {
    return (
        <div styleName='detail--full'>
            <div styleName='detail-name'>Lead</div>
            <div styleName='company-lead'>
                <Link
                    as={RoutedLink}
                    to={props.htmlUrlPath}
                    onClick={props.onClose}
                    size='small'
                    preventUnderline={true}
                >
                    <div styleName='lead-content'>
                        <TwoLine
                            topRow={props.leadName}
                            bottomRow={props.primaryContactName}
                            avatar={
                                <div styleName='avatar-wrapper'>
                                    <LeadAvatar avatarUrl={props.avatarUrl} />
                                </div>
                            }
                        />
                        <div>
                            <strong>{props.formattedValue}</strong>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    );
}
